import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'react-apollo';
import { redirectNoRouteAccess } from 'legacy/src/components/auth/utils';
import { withMeQuery } from 'legacy/src/components/util';
import { clearDefaultEducationPeriod as clearDefaultEducationPeriodAction } from 'legacy-src/actions/educationPeriod';
import * as types from 'legacy/src/constants/types';

/**
 * @classdesc Permissions Container component
 * @param {object} params Router params
 * @param {array} routes Routes list
 * @param {array} nav Navigation redux store object
 * @param {object} router The react router handler
 * */
export default (WrappedComponent) => {
  class PermissionsContainer extends Component {
    static displayName = 'PermissionsContainer';

    constructor(props) {
      super(props);

      this.permissionsCheck = this.permissionsCheck.bind(this);
    }

    componentDidMount() {
      this.permissionsCheck(this.props);
    }

    componentDidUpdate(prevProps) {
      const {
        params: { subject },
        meQuery,
        userData,
        clearDefaultEducationPeriod,
      } = this.props;
      const {
        params: { subject: prevSubject },
      } = prevProps;
      if (prevSubject && prevSubject !== subject) {
        meQuery.refetch();
        clearDefaultEducationPeriod({ subject, userData });
      }
      this.permissionsCheck(this.props);
    }

    /**
     * Redirects to home page when path is not found
     * @param {object} props The component properties
     * */
    // eslint-disable-next-line class-methods-use-this
    permissionsCheck(props) {
      const {
        data,
        userData,
        params,
        routes,
        router,
        nav: { loading, data: navData },
      } = props;
      if (!loading) {
        const { teacherSubjects } = userData;
        const { teacherSubject } = data;
        const masterSubject = teacherSubjects.find(
          (obj) => params.subject === obj.id,
        );

        const restrictedRoutes = {};
        if (
          masterSubject &&
          masterSubject.subjectProgram === types.PreAP &&
          teacherSubject &&
          teacherSubject.contentExpired
        ) {
          if (routes[3].path.toUpperCase() === 'HOME') {
            router.replace(`/${params.subject}/assessments/results`);
            return;
          }
          restrictedRoutes.Home = 'HOME';
        }

        redirectNoRouteAccess({
          params,
          route: routes[3].path,
          navData: navData,
          router,
          restrictedRoutes,
        });
      }
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  function mapStateToProps(state) {
    const { nav, featureFlag, subject, userData } = state;
    return {
      nav,
      userData,
      showQuizBuilder: featureFlag.quiz_builder,
      subjectData: subject.data,
    };
  }

  return compose(
    connect(mapStateToProps, {
      clearDefaultEducationPeriod: clearDefaultEducationPeriodAction,
    }),
    withMeQuery,
  )(PermissionsContainer);
};
